import { Link } from "react-router-dom";
import { useSeo } from "../components/Seo";

export default function NotFound() {
    useSeo({
        title: "Page not found — HALTONS.CA",
        description: "The page you are looking for could not be found on HALTONS.CA.",
        path: "/404",
    });

    return (
        <main data-testid="not-found-page" className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6">
            <p className="font-serif-display text-6xl font-bold text-gold">404</p>
            <h1 className="mt-4 font-serif-display text-3xl font-semibold text-navy">
                Page not found
            </h1>
            <p className="mt-3 text-sm text-muted-foreground">
                The page you are looking for does not exist or has been moved.
            </p>
            <Link
                to="/"
                data-testid="not-found-home-link"
                className="mt-8 inline-block bg-navy px-6 py-3 text-sm font-semibold text-ivory transition-colors hover:bg-teal"
            >
                Return to the homepage
            </Link>
        </main>
    );
}
